import id from '@/helpers/id'

/**
 * Created by Fernando Torres on 15/03/2018.
 */
export default {
  model () {
    return {
      $id: id(),
      $collapsed: false,
      $group: 'question',
      name: '',
      type: '',
      sectionId: null,
      evidenceRequired: false,
      helper: '',
      description: '',
      index: null
    }
  },
  rules: {
    name: { required: true, message: 'Es requerido escribir una pregunta', trigger: 'blur' },
    type: { required: true },
    sectionId: {required: true},
    evidenceRequired: {},
    helper: {},
    description: {},
    index: {required: true}
  }
}



// WEBPACK FOOTER //
// ./src/modules/designer/api/question.model.js